import { WordpressPost } from "contentlayer/generated";

const formatter = new Intl.DateTimeFormat("th-TH", {
  year: "numeric",
  month: "long",
  day: "numeric"
});

const fallbackImages = ["/images/blog-boi.svg", "/images/blog-report.svg", "/images/blog-payroll.svg", "/images/blog-cfo.svg"];

export const blogCategories = [
  { slug: "tax", label: "ภาษี", description: "ภาษีมูลค่าเพิ่ม ภาษีเงินได้ และหน้าที่ที่ผู้ประกอบการควรรู้" },
  { slug: "accounting-finance", label: "บัญชีและการเงิน", description: "พื้นฐานบัญชี งบการเงิน และข้อมูลที่ช่วยบริหารกิจการ" },
  { slug: "business-registration", label: "จดทะเบียนธุรกิจ", description: "การจัดตั้ง เปลี่ยนแปลง และจัดการข้อมูลนิติบุคคล" },
  { slug: "people-management", label: "พนักงานและเงินเดือน", description: "เงินเดือน ประกันสังคม และเอกสารที่เกี่ยวข้องกับพนักงาน" },
  { slug: "forms-documents", label: "แบบฟอร์มและเอกสาร", description: "ตัวอย่างเอกสารและแนวทางเตรียมหลักฐานทางธุรกิจ" },
  { slug: "business-knowledge", label: "ความรู้ธุรกิจ", description: "แนวคิดพื้นฐานสำหรับเจ้าของกิจการและธุรกิจที่กำลังเติบโต" }
] as const;

const categoryLabelMap = Object.fromEntries(
  blogCategories.map((category) => [category.slug, category.label])
) as Record<string, string>;

const stripHtml = (html: string) => {
  return html.replace(/<!--.*?-->/gs, "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
};

const truncate = (value: string, length?: number | null) => {
  if (typeof length !== "number" || Number.isNaN(length) || length <= 0) {
    return value;
  }
  if (value.length <= length) {
    return value;
  }
  return `${value.slice(0, length).trimEnd()}…`;
};

export const parseGmtDate = (value: string) => {
  const normalized = value.replace(" ", "T");
  return new Date(`${normalized}Z`);
};

export const formatThaiDate = (post: WordpressPost) => {
  const date = parseGmtDate(post.dateGmt || post.date);
  return formatter.format(date);
};

export const buildExcerpt = (post: WordpressPost, length?: number | null) => {
  const base = post.excerpt?.trim() || stripHtml(post.content);
  if (!base) {
    return "";
  }
  const limit = typeof length === "undefined" ? 160 : length;
  return truncate(base, limit);
};

export const pickFallbackImage = (index: number) => {
  return fallbackImages[index % fallbackImages.length];
};

export const formatCategoryLabel = (slug?: string | null) => {
  if (!slug) {
    return "ความรู้ธุรกิจ";
  }
  if (categoryLabelMap[slug]) {
    return categoryLabelMap[slug];
  }
  return slug
    .split("-")
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(" ");
};
